/**
 * If <shopify-account> never hydrates (no shadow root), clicks do nothing.
 * After a short delay, send the user to the same URL the theme would use for account / login.
 */
const DATA_ATTR = 'data-account-fallback-url';

function attachFallbacks() {
  for (const wrap of document.querySelectorAll(`[${DATA_ATTR}]`)) {
    if (wrap.dataset.accountShopifyFallback === 'attached') continue;

    const url = wrap.getAttribute(DATA_ATTR);
    const el = wrap.querySelector('shopify-account');
    if (!url || !el) continue;

    window.setTimeout(() => {
      if (wrap.dataset.accountShopifyFallback === 'attached') return;
      if (el.shadowRoot) return;

      wrap.dataset.accountShopifyFallback = 'attached';
      wrap.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.assign(url);
        },
        true
      );
      wrap.style.cursor = 'pointer';
    }, 2800);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', attachFallbacks);
} else {
  attachFallbacks();
}
